import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ResourceEditAddFieldsModule } from '®app/resource/edit/add-fields/resource-edit-add-fields.module';
import { BibliographicResourceService } from '®shared/bibliographic-resource';

import { ResourceEditFormComponent } from './resource-edit-form.component';
import { ResourceEditSmartComponent } from './resource-edit-smart.component';
import { ResourceEditComponent } from './resource-edit.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, ResourceEditAddFieldsModule],
  declarations: [
    ResourceEditSmartComponent,
    ResourceEditComponent,
    ResourceEditFormComponent,
  ],
  exports: [ResourceEditComponent, ResourceEditFormComponent],
  providers: [BibliographicResourceService],
})
export class ResourceEditModule {}
